import React, { useEffect, useRef, useState } from 'react'
import './Mainpage.css'
import Dialog from '../Dialog/Dialog';
import search from "../../imgs/search.png";
import premium from "../../imgs/premium.png";
import youandher from "../../imgs/youandher.png";
import bdate from "../../imgs/bdate.png";
import gender from "../../imgs/gender.png";
import marrstatus from "../../imgs/marrstatus.png";
import district from "../../imgs/district.png";
import bgrp from "../../imgs/bgrp.png";
import community from "../../imgs/community.png";
import profession from "../../imgs/profession.png";
import income from "../../imgs/income.png";
import education from "../../imgs/education.png";
import navras from "../../imgs/navras.png";
import naksh from "../../imgs/naksh.png";
import gan from "../../imgs/gan.png";
import nadi from "../../imgs/nadi.png";
import gotra from "../../imgs/gotra.png";
import kdvt from "../../imgs/kdvt.png";
import devak from "../../imgs/devak.png";
import whitecall from "../../imgs/whitecall.png";
import address from "../../imgs/address.png";
import logoutlogo from "../../imgs/logout.png";

import home from "../../imgs/home.png";
import homeselected from "../../imgs/homeselected.png";
import matches from "../../imgs/matches.png";
import matchesselected from "../../imgs/matchesselected.png";
import help from "../../imgs/help.png";
import helpselected from "../../imgs/helpselected.png";
import chat from "../../imgs/chat.png";
import chatselected from "../../imgs/chatselected.png";
import premium2 from "../../imgs/premium2.png";
import premiumselected from "../../imgs/premiumselected.png";
import dot from "../../imgs/dot.png";
import { optionsdata } from "../../Data/Data";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Viewprofile from '../Viewprofile/Viewprofile';

const Mainpage = () => {
  const [current, setCurrent] = useState(0);
  const [cmenu, setCmenu] = useState(1);
  const navigate = useNavigate();
  const notify = (msg) => toast(msg);
  const [DataSource, setDataSource] = useState([]);
  const [DataSourcepr, setDataSourcepr] = useState([]);
  const refprofile = useRef(null);
  const refprofileclose = useRef(null);
  const refsearch = useRef(null);
  const refsearcheclose = useRef(null);
  const refhelp = useRef(null);
  const refhelpclose = useRef(null);
  const refplan = useRef(null);
  const refphoto = useRef(null);
  const refphotoclose = useRef(null);
  const refplanclose = useRef(null);
  const [showconfirm, setShowconfirm] = useState(false);
  const refviewclose = useRef(null);
  const [sr, setSr] = useState();
  const [exist, setExist] = useState("");
  const [contactdata, setContactdata] = useState({ mobno: "****************", amobno: "********************************", address: "********************************" });
  const breakline = '\u000A';
  const [searchsr, setSearchsr] = useState({ searchsr1: "" });
  const [path, setPath] = useState("photo");

  const [dialog, setDialog] = useState({
    message: "",
    isLoading: false,
    nameProduct: ""
  });


  useEffect(() => {
    if (localStorage.getItem("sr") === "") {
      navigate("/customer");
    }
  }, [])

  const handleChangesearch = (event) => {
    const name = event.target.name;
    const valuecurrent = event.target.value;

    setSearchsr(value => ({ ...value, [name]: valuecurrent }))
  }


  const logout = () => {
    localStorage.setItem("name", "");
    localStorage.setItem("age", "");
    localStorage.setItem("jat", "");
    localStorage.setItem("vtype", "");
    localStorage.setItem("quli", "");
    localStorage.setItem("fdate", "");
    localStorage.setItem("dist", "");
    localStorage.setItem("sr", "");
    notify("लॉग आऊट यशस्वी झाले.");
    navigate("/customer");

  };

  const handlephoto = () => {
    if (path === "photo") {
      setPath("photo2")
    }
    else if (path === "photo2") {
      setPath("photo3")
    }
    else if (path === "photo3") {
      setPath("photo")
    }

  }
  useEffect(() => {
    console.log(path);
  }, [path])

  const areUSure = (choose) => {
    if (choose) {
      handleDialog("", false);
    } else {
      handleDialog("", false);
    }
  };

  const handleDialog = (message, isLoading, nameProduct) => {
    setDialog({
      message,
      isLoading,
      nameProduct
    });
  };

  useEffect(() => {
    if (current === 0) {
      getjatsthale();
    }
  }, [])

  const handleactive = (index) => {
    setCurrent(index);
    if (index === 0) {
      getjatsthale();
    }
    else if (index === 1) {
      getnewsthale();
    }
    else if (index === 2) {
      getsecondsthale();
    }
    else if (index === 3) {
      getqulisthale();
    }
    else if (index === 4) {
      getdiststhale();
    }
    else if (index === 5) {
      refsearch.current.click();
    }
    else if (index === 6) {
      getvisitedtome();
    }
    else if (index === 8) {
      getshortlisted();
    }
    else if (index === 9) {
      getseensthale();
    }
    else if (index === 10) {
      getmadhsthale();
    }


  }

  const openprofile = (srr) => {
    setSr(srr);
    refprofile.current.click();
    getaccountdata(srr);
  }

  const showcontacts = () => {
    {
      DataSourcepr.map((user, index) => (
        setContactdata({ mobno: user.mobno, amobno: user.amobno, address: user.address })
      ))
    }
    getvisited();
  }

  const clearcontact = () => {
    refprofileclose.current.click();
    setContactdata({ mobno: "****************", amobno: "********************************", address: "********************************" });
    setShowconfirm(false);
  }

  const openhelp = () => {
    refhelp.current.click();
  }

  const openpremium = () => {
    refplan.current.click();
  }


  const viewcontact = () => {

  }

  const confirmcontact = () => {
    setShowconfirm(!showconfirm);

  }

  const sendtomadhysti = () => {
    if (localStorage.getItem("madh") === "Yes") {
      let rawData = {
        senderid: localStorage.getItem("sr"),
        viewid: sr,
        brnomadh: localStorage.getItem("brnomadh"),

      }
      rawData = JSON.stringify(rawData)
      let formData = new FormData()
      formData.append('data', rawData)

      axios.post('https://softtesting.in/php/cust/savemadhweb.php', formData, {
        'Content-Type': 'multipart/form-data',

      }).then(function sample(response) {
        notify(response.data);

      }).catch(err => {
        console.log(err);
      });
    }
    else {
      notify("हि सुविधा सुरु नाही.")
    }
  }

  const getjatsthale = () => {
    let rawData = {
      jat: localStorage.getItem("jat"),
      sr: localStorage.getItem("sr"),
      vtype: localStorage.getItem("vtype"),
      age: localStorage.getItem("age"),
      dist: "Not set",
      max: "0",
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/getaccjatweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setDataSource(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const getnewsthale = () => {
    let rawData = {
      jat: localStorage.getItem("jat"),
      sr: localStorage.getItem("sr"),
      vtype: localStorage.getItem("vtype"),
      age: localStorage.getItem("age"),
      dist: "Not set",
      max: "0",
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/getnewweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setDataSource(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const getsecondsthale = () => {
    let rawData = {
      jat: localStorage.getItem("jat"),
      sr: localStorage.getItem("sr"),
      vtype: localStorage.getItem("vtype"),
      age: localStorage.getItem("age"),
      dist: "Not set",
      max: "0",
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/getsecondweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setDataSource(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const getqulisthale = () => {
    let rawData = {
      jat: localStorage.getItem("jat"),
      sr: localStorage.getItem("sr"),
      vtype: localStorage.getItem("vtype"),
      age: localStorage.getItem("age"),
      edu: localStorage.getItem("quli"),
      dist: "Not set",
      max: "0",
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/getquliweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setDataSource(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const getdiststhale = () => {
    let rawData = {
      jat: localStorage.getItem("jat"),
      sr: localStorage.getItem("sr"),
      vtype: localStorage.getItem("vtype"),
      age: localStorage.getItem("age"),
      dist: localStorage.getItem("dist"),
      max: "0",
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/getdistweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setDataSource(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const getvisitedtome = () => {
    let rawData = {
      sr: localStorage.getItem("sr"),
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/getvisitedweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {

      setDataSource(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const getshortlisted = () => {
    let rawData = {
      sr: localStorage.getItem("sr"),
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/getshortlistedweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setDataSource(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const getseensthale = () => {
    let rawData = {
      sr: localStorage.getItem("sr"),
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/getseenweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setDataSource(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const getmadhsthale = () => {
    let rawData = {
      sr: localStorage.getItem("sr"),
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/getmadhweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setDataSource(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const getaccountdata = (srrr) => {
    let rawData = {
      sr: srrr,
      rootsr: localStorage.getItem("sr"),
      veri: "-",
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/getaccountdataweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setDataSourcepr(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  useEffect(() => {
    alreadyexist();
  }, [DataSourcepr])

  const getvisited = () => {
    let rawData = {
      visitperson: localStorage.getItem("sr"),
      name: localStorage.getItem("sr"),
      visitedto: sr,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/visit2web.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {


    }).catch(err => {
      console.log(err);
    });
    setExist("exist");
    setShowconfirm(false);
  }

  const alreadyexist = () => {
    let rawData = {
      visitperson: localStorage.getItem("sr"),
      name: localStorage.getItem("sr"),
      visitedto: sr,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://softtesting.in/php/cust/alreadyexistweb.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      if (response.data === "Exist") {
        setExist("exist");
        {
          DataSourcepr.map((user, index) => (
            setContactdata({ mobno: user.mobno, amobno: user.amobno, address: user.address })
          ))
        }
      }
      else {
        setExist("new");
        setContactdata({ mobno: "****************", amobno: "********************************", address: "********************************" });
      }
    }).catch(err => {
      console.log(err);
    });
  }

  return (
    <>
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={refphoto}
        data-bs-target="#exampleModalphoto"
      >
      </button>

      <div className="modal fade" id="exampleModalphoto" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '80vw' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Photo Gallary</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refphotoclose} aria-label="Close">
              </button>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column" }} className="modal-body">

            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={refplan}
        data-bs-target="#exampleModalplan"
      >
      </button>

      <div className="modal fade" id="exampleModalplan" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '80vw' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">प्रिमियम मध्ये अपग्रेड व्हा</h5>

              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refplanclose} aria-label="Close">
              </button>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column" }} className="modal-body">
              <span className='regularboldmain'>खालील पैकी कोणताही प्लान निवडा व अनेक स्थळे मिळवा</span>
              <div className="planmain">
                <div className="card">
                  <span className='regular'>Gold 1 Year</span>
                  <div className="linecard"></div>
                  <span className='regularboldmain'>14999/-</span>
                  <span className='regular'>1249/- प्रती महिना</span>
                  <div className="pointmain">
                    <div className="planpoint">
                      <img className='smalllogo' src={premium} alt="" />
                      <span className='regularbold'>अनलिमिटेड मेसेज पाठवा</span>
                    </div>
                    <div className="planpoint">
                      <img className='smalllogo' src={premium} alt="" />
                      <span className='regularbold'>३६५ प्रोफाईल मोबाईल क्रमांक मिळवा</span>
                    </div>
                    <div className="planpoint">
                      <img className='smalllogo' src={premium} alt="" />
                      <span className='regularbold'>Google Pay Number - 9175934454</span>
                    </div>
                    <div className="usercountbutton">
                      <span className='regularblue'>ok</span>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <span className='regular'>Silver 6 Months</span>
                  <div className="linecard"></div>
                  <span className='regularboldmain'>5999/-</span>
                  <span className='regular'>1000/- प्रती महिना</span>
                  <div className="pointmain">
                    <div className="planpoint">
                      <img className='smalllogo' src={premium} alt="" />
                      <span className='regularbold'>अनलिमिटेड मेसेज पाठवा</span>
                    </div>
                    <div className="planpoint">
                      <img className='smalllogo' src={premium} alt="" />
                      <span className='regularbold'>३६५ प्रोफाईल मोबाईल क्रमांक मिळवा</span>
                    </div>
                    <div className="planpoint">
                      <img className='smalllogo' src={premium} alt="" />
                      <span className='regularbold'>Google Pay Number - 9175934454</span>
                    </div>
                    <div className="usercountbutton">
                      <span className='regularblue'>ok</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>


      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={refhelp}
        data-bs-target="#exampleModalhelp"
      >
      </button>

      <div className="modal fade" id="exampleModalhelp" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '80vw' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">मदत</h5>

              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refhelpclose} aria-label="Close">
              </button>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column" }} className="modal-body">
              <span className='regularboldmain'>साधारण विचारले जाणारे प्रश्न</span>
              <span style={{ marginTop: "30px" }} className='regularbold'>प्रिमियम प्लान घेण्याचे काय फायदे आहेत?</span>
              <span style={{ marginTop: "10px", marginLeft: "10px" }} className='regular'>आमचा प्रीमियम प्लान घेतल्याने तुम्हाला तुमच्या आवडणार्‍या स्थळासोबत चॅटिंग करता येते,तसेच तुम्हाला स्थळांचा मोबाईल क्रमांक पाहता येईल,तसेच काही प्लान मध्ये तुम्हाला आमच्या प्रतींनिधिकडून मध्यस्थी ही घेता येते.</span>
              <span style={{ marginTop: "20px" }} className='regularbold'>पेमेंट कसे कराल?</span>
              <span style={{ marginTop: "10px", marginLeft: "10px" }} className='regular'>आम्ही आपणास दोन्ही ऑनलाइन व ऑफलाइन माध्यमातून पेमेंट करायची सुविधा दिली आहे,तुम्ही तुम्हाला हव्या त्या माध्यमातून पेमेंट करू शकता.</span>
              <span style={{ marginTop: "20px" }} className='regularbold'>मला कोणत्या ओफर्स व डिसकौंट्स मिळू शकतात?</span>
              <span style={{ marginTop: "10px", marginLeft: "10px" }} className='regular'>आम्ही आपणास डिसकौंट्स व ऑफर्स बद्दल वेळोवेळी माहिती देत असतो,आपण नोटिफिकेशन पाहू शकता!</span>
              <span style={{ marginTop: "20px" }} className='regularbold'>MarriageBuero.com मध्ये माझी माहिती सुरक्षित आहे का?</span>
              <span style={{ marginTop: "10px", marginLeft: "10px" }} className='regular'>Marrigebuero.com मध्ये आपले प्रोफाइल पुर्णपणे सुरक्षित आहे,त्याचबरोबर मॅरेज ब्यूरो मध्ये प्रत्येक प्रोफाइल व्हेरिफाय करूनच घेतले जाते.तरीपण तुम्हाला कोणत्याही प्रोफाइल बद्दल शंका असेल तर ते प्रोफाइल तुम्ही रेपोर्ट करून आम्हाला कळवू शकता.</span>
              <div className="linecard"></div>
              <div className="ehelp">
                <span className='regularboldmain'>अजूनही मदतीची गरज आहे?</span>
                <span style={{ marginTop: "10px", marginLeft: "10px" }} className='regular'>आम्ही आपल्या मदतीकरिता कायम येथे उपलब्ध आहोत,आपण आम्हाला सकाळी 9 ते रात्री 7 पर्यन्त कधीही कॉल करू शकता!</span>
                <span style={{ marginTop: "10px", marginLeft: "10px" }} className='regularbold'>महाराष्ट्र  +91-9175934454</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={refsearch}
        data-bs-target="#exampleModalsearch"
      >
      </button>

      <div className="modal fade" id="exampleModalsearch" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">प्रोफाईल शोधा</h5>

              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refsearcheclose} aria-label="Close">
              </button>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }} className="modal-body">
              <input style={{ width: "90%" }} className="form-control search mx-3 my-3" onChange={handleChangesearch} maxLength="10" type="text" id="searchsr1" name="searchsr1" placeholder='आयडी क्रमांक भरा' />
              <button style={{ alignSelf: "center" }} type="button" onClick={() => openprofile(searchsr.searchsr1)} className='btn btn-primary my-1 mx-1'>show</button>
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={refprofile}
        data-bs-target="#exampleModaldelete"
      >
      </button>

      <div className="modal fade" id="exampleModaldelete" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '80vw' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel"></h5>

              <button type="button" className="btn-close" onClick={clearcontact} data-bs-dismiss="modal" ref={refprofileclose} aria-label="Close">
              </button>
            </div>
            <div className="modal-body">
                <Viewprofile DataSource={DataSource} DataSourcepr={DataSourcepr} handlephoto={handlephoto} path={path} contactdata={contactdata} showconfirm={showconfirm} showcontacts={showcontacts} exist={exist} sendtomadhysti={sendtomadhysti} confirmcontact={confirmcontact} user ={"cust"}/>
            </div>
          </div>
        </div>
      </div>



      <div className='mainpagemain'>
        <div className="mainpageback">
          <div className="options">
            <img className='smalllogo' src={search} alt="" />
            {optionsdata.map((card, index) => {
              return (
                <div onClick={() => handleactive(index)} className={current === index ? 'obuttonactive' : 'obutton'} key={index}> {card.title} </div>
              );
            })}
          </div>
          <div className="midbox">
            <span className='regularbold'>आपल्या {localStorage.getItem("jat")} समाजातील स्थळे</span>
            <div className="profileboxmain">
              {DataSource.map((user, index) => (

                <div onClick={() => openprofile(current === 10 ? user.viewid : current === 9 ? user.visitedto : current === 8 ? user.shortsr : current === 6 ? user.visitperson : user.sr)} style={{ backgroundImage: `url(https://softtesting.in/photo/${current === 10 ? user.viewid : current === 9 ? user.visitedto : current === 8 ? user.shortsr : current === 6 ? user.visitperson : user.sr}.jpg)`, backgroundSize: '100% 100%' }} className="profile">
                  <div className="matter">
                    <div className="mattersub">
                      <div className="namerow">
                        <img className='smalllogo' src={premium} alt="" />
                        <span className='name'>{user.name}</span>
                        <img className='smalllogo' src={youandher} alt="" />
                        <span style={{ fontFamily: "'Mukta', sans-serif", fontSize: '10px', color: "white" }}>You and her</span>
                      </div>
                      <div className="namerow">
                        <span className='regularsmall'>{user.age} Yrs, {user.height}"</span>
                        <img className='smalllogo2' src={dot} alt="" />
                        <span className='regularsmall'>{user.qulidetails}</span>
                      </div>
                      <div className="namerow">
                        <span className='regularsmall'>{user.bdate}</span>
                        <img className='smalllogo2' src={dot} alt="" />
                        <span className='regularsmall'>{user.jat}</span>

                      </div>
                    </div>
                  </div>
                </div>

              )
              )}

            </div>
          </div>
          <div className="menubar">
            <div className="menubarmain">
              <div onClick={() => openprofile(localStorage.getItem("sr"))} className="menu">
                <img className='smalllogo' src={cmenu === 0 ? homeselected : home} alt="" />
                <span className={cmenu === 0 ? 'menutextselected' : 'menutextgray'}>माझे खाते</span>
              </div>
              <div className="menu">
                <img className='smalllogo' src={cmenu === 1 ? matchesselected : matches} alt="" />
                <span className={cmenu === 1 ? 'menutextselected' : 'menutextgray'}>जुळणारी स्थळे</span>
              </div>
              <div onClick={() => openhelp()} className="menu">
                <img className='smalllogo' src={cmenu === 2 ? helpselected : help} alt="" />
                <span className={cmenu === 2 ? 'menutextselected' : 'menutextgray'}>मदत</span>
              </div>
              <div onClick={() => openpremium()} className="menu">
                <img className='smalllogo' src={cmenu === 3 ? premiumselected : premium2} alt="" />
                <span className={cmenu === 3 ? 'menutextselected' : 'menutextgray'}>प्रीमियम सेवा</span>
              </div>
              <div onClick={() => logout()} className="menu">
                <img className='smalllogo' src={cmenu === 4 ? logoutlogo : logoutlogo} alt="" />
                <span className={cmenu === 3 ? 'menutextselected' : 'menutextgray'}>लॉग आऊट</span>
              </div>

            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default Mainpage
